import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { key: 1 }

import TextEditor from '@/components/tech/TextEditor.vue'
import { ref } from 'vue';
import { TicketItemModel } from '@/app.context/workspace/tickets/_spec/Ticket.Item.Model';
import { stateObject, descriptionSubmit } from './ticket.controller.model';




export default /*#__PURE__*/_defineComponent({
  __name: 'TicketDescription',
  props: {
    model: {}
  },
  setup(__props: any) {

const editor = ref<InstanceType<typeof TextEditor> | null>(null)

    editor.value?.focus()

const props = __props

const state = stateObject(props.model)

function onEdit(){

    state.edit.description = true

    editor.value?.focus()

}

//const emit = defineEmits(['close'])



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", null, [
      _createTextVNode("#" + _toDisplayString(_ctx.model.ticket?.n) + " - " + _toDisplayString(_ctx.model.ticket?.name) + " ", 1),
      _withDirectives(_createElementVNode("i", {
        class: "bi-pen clickable",
        onClick: onEdit
      }, null, 512), [
        [_vShow, !_unref(state).edit.description]
      ]),
      _withDirectives(_createElementVNode("i", {
        class: "bi-check-lg clickable",
        onClick: _cache[0] || (_cache[0] = () => _unref(state).edit.description = false)
      }, null, 512), [
        [_vShow, _unref(state).edit.description]
      ])
    ]),
    (_ctx.model.pack)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 0,
          innerHTML: _ctx.model.pack.description
        }, null, 8, _hoisted_1)), [
          [_vShow, !_unref(state).edit.description]
        ])
      : _createCommentVNode("", true),
    (_ctx.model.pack)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(TextEditor, {
            ref_key: "editor",
            ref: editor,
            modelValue: _ctx.model.pack.description ?? '',
            onSubmit: _cache[1] || (_cache[1] = (content) => _unref(descriptionSubmit)(_ctx.model, content, _unref(state)))
          }, null, 8, ["modelValue"])
        ], 512)), [
          [_vShow, _unref(state).edit.description]
        ])
      : _createCommentVNode("", true)
  ]))
}
}

})